import { createContext } from "react";

export const ComboboxContext = createContext<{
  multiple: boolean;
  removable: boolean;
  onSelect: (value: any) => void;
  onRemove: (value: any) => void;
  truncate?: boolean;
}>(null as any);

export const ComboboxSelectedContext = createContext(false);
